import * as setup from 'setup';
import styled from 'styled-components';

export const FunnelStepContainer = styled.div<FunnelStepContainerProps>`
    ${({ $hide }) => $hide ? '& > * { visibility: hidden; }' : ''};
    background-color: ${({ $hide }) => $hide ? setup.colors.transparent : setup.colors.white};
    border-radius: 5px;
    border: ${({ $hide }) => $hide ? '1px dashed #000' : '1px solid #e0e0e0'};
    box-shadow: ${({ $hide }) => $hide ? 'none' : '4px 4px 4px 0px rgba(0, 0, 0, 0.2)'};
    position: relative;
    width: ${({ $index }) => `${500 - ($index * 40)}px`};
    z-index: 1;
`;